import React from 'react'
import { useTicketsInfo } from './ticket/info.hook'

export function useTicketsMap(entries: { ticketId: number }[] | undefined, executeFetch: boolean) {
    const ticketIds = React.useMemo(() => (entries ?? []).map((entry) => entry.ticketId), [entries])

    const ticketsInfo = useTicketsInfo(ticketIds, executeFetch)

    const ticketsMap = React.useMemo(
        () => new Map(ticketsInfo.map((ticketInfo) => [ticketInfo.ticketInfo?.id, ticketInfo])),
        [ticketsInfo]
    )

    return ticketsMap
}
